import { useEffect } from 'react';

import { usePartnerConfig } from '@percent/hosted-validation-form/hooks';

import { CardProps } from './Card.types';
import { Step } from '@percent/domain/verifications';

export const Card = ({
  children,
  title,
  isError,
  description,
  isLoading,
  nextButtonDisabled,
  nextButtonLabel,
  onBack,
  onNext,
  progress,
}: CardProps) => {
  const { partnerConfig, setPartnerConfig } = usePartnerConfig();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (isError && partnerConfig) {
      setPartnerConfig({
        ...partnerConfig,
        configuration: { ...partnerConfig.configuration, primaryColor: '#ffffff' },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError]);

  return (
    <Step
      children={children}
      title={title}
      description={description}
      onBack={onBack}
      onNext={onNext}
      nextButtonDisabled={nextButtonDisabled}
      progress={progress}
      nextButtonLabel={nextButtonLabel}
      isLoading={isLoading}
    />
  );
};
